import React from 'react';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { theme } from 'styles/theme/theme';

interface SubscriptionTopupSuccessProps {
  onDone: () => void;
}

export const SubscriptionTopupSuccess: React.FC<SubscriptionTopupSuccessProps> = ({ onDone }) => {
  return (
    <div className="flex flex-col gap-3">
      <UDText type="headline">Баланс пополнен</UDText>
      <UDText type="body-text" color={theme.colors.Gray}>
        Средства зачислены на кошелёк. Тариф подключается отдельной кнопкой «Оплатить с баланса».
      </UDText>
      <UDButton type="button" variant="primary" onClick={onDone}>
        Готово
      </UDButton>
    </div>
  );
};
